module.exports = __webpack_public_path__ + "img/icon-play.91a7ead7.svg";